"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WE_GAME_URL = exports.VALIDATION_2_URL = exports.UPLOAD_URL = exports.SQGameServer_URL = exports.SEND_MSG_SOURCE_TYPE = exports.RESPONSE_STATUS = exports.REGISTER_URL = exports.REGISTER_OVERSEAS_URL = exports.REALNAME_URL = exports.REALNAME_DETAIL_URL = exports.PAY_OVERSEAS_URL = exports.MOBILE_AUTH_URL = exports.MINUTE = exports.MESSAGE_API_URL = exports.LOGO_URL = exports.HOST_URL = exports.GYYX_URL = exports.GYYX_OVERSEAS_URL = exports.GYYX_APP_URL = exports.FORGET_PASSWORD_URL = exports.FORGET_PASSWORD_OVERSEAS_URL = exports.DURATION = exports.CUSTOMER_SERVICE_OVERSEAS_URL = exports.COOKIE_KEY = exports.API_URL = exports.AGREEMENT_URL = exports.AGREEMENT_PRIVACY_URL = exports.ACCOUNT_URL = exports.ACCOUNT_UI_URL = exports.ACCOUNT_OVERSEAS_URL = void 0;
/*
 * @Author: liujunhong
 * @Date: 2022/9/24
 * @Desc: 公用常量
 */
var GYYX_URL = '//www.gyyx.cn/';
// 海外
exports.GYYX_URL = GYYX_URL;
var GYYX_OVERSEAS_URL = '//roadrich.gyyx.cn/';
// cookie
exports.GYYX_OVERSEAS_URL = GYYX_OVERSEAS_URL;
var COOKIE_KEY = 'GYYX_CHECKCODE_STAGE_V1';
// 光宇app
exports.COOKIE_KEY = COOKIE_KEY;
var GYYX_APP_URL = '//wd.gyyx.cn/huodong/app/index.html';
// 实名认证前往
exports.GYYX_APP_URL = GYYX_APP_URL;
var REALNAME_URL = '//accountv2.gyyx.cn/realname/index';
// 实名认证详情
exports.REALNAME_URL = REALNAME_URL;
var REALNAME_DETAIL_URL = '//wd.gyyx.cn/News/NewsDetail_New.aspx?NewsID=81413';
// 短消息的接口站点
exports.REALNAME_DETAIL_URL = REALNAME_DETAIL_URL;
var MESSAGE_API_URL = '//securityv5.gyyx.cn/v1/sms/send';
// 手机认证
exports.MESSAGE_API_URL = MESSAGE_API_URL;
var MOBILE_AUTH_URL = '//security.gyyx.cn/mobilephone/AjaxGetAuthed';
// 账号中心
exports.MOBILE_AUTH_URL = MOBILE_AUTH_URL;
var ACCOUNT_URL = '//account.gyyx.cn/';
// we game
exports.ACCOUNT_URL = ACCOUNT_URL;
var WE_GAME_URL = '//we.gyyx.cn/';
// 海外账号中心
exports.WE_GAME_URL = WE_GAME_URL;
var ACCOUNT_OVERSEAS_URL = '//account.gyyx.cn/HaiWai';
exports.ACCOUNT_OVERSEAS_URL = ACCOUNT_OVERSEAS_URL;
var ACCOUNT_UI_URL = '//account.gyyx.cn';
// 注册
exports.ACCOUNT_UI_URL = ACCOUNT_UI_URL;
var REGISTER_URL = '//account.gyyx.cn/Member/Register';
// 海外注册
exports.REGISTER_URL = REGISTER_URL;
var REGISTER_OVERSEAS_URL = "".concat(ACCOUNT_OVERSEAS_URL, "/Account/Register");
// 忘记密码
exports.REGISTER_OVERSEAS_URL = REGISTER_OVERSEAS_URL;
var FORGET_PASSWORD_URL = '//account.gyyx.cn/Member/ForgetPassword';
// 海外忘记密码
exports.FORGET_PASSWORD_URL = FORGET_PASSWORD_URL;
var FORGET_PASSWORD_OVERSEAS_URL = "".concat(ACCOUNT_OVERSEAS_URL, "/account/forgetPassword");
// api
exports.FORGET_PASSWORD_OVERSEAS_URL = FORGET_PASSWORD_OVERSEAS_URL;
var HOST_URL = '//accountv5.gyyx.cn';
exports.HOST_URL = HOST_URL;
var API_URL = "".concat(HOST_URL, "/v1/account");
// 协议
exports.API_URL = API_URL;
var AGREEMENT_URL = '//www.gyyx.cn/Resource/Agreement#Terms';
// 隐私政策
exports.AGREEMENT_URL = AGREEMENT_URL;
var AGREEMENT_PRIVACY_URL = '//www.gyyx.cn/Resource/Agreement#Privacy';
// logo
exports.AGREEMENT_PRIVACY_URL = AGREEMENT_PRIVACY_URL;
var LOGO_URL = '//s.gyyx.cn/publictop/images/toplogo_201612.jpg';
// 获取区组域名 updata at 2022-11-23
exports.LOGO_URL = LOGO_URL;
var SQGameServer_URL = '//apicloud.gyyx.cn';
// 海外游戏充值
exports.SQGameServer_URL = SQGameServer_URL;
var PAY_OVERSEAS_URL = '//pay.gyyx.cn/haiwai/AlipayGYQrcode/PayGold';
// 海外客服中心
exports.PAY_OVERSEAS_URL = PAY_OVERSEAS_URL;
var CUSTOMER_SERVICE_OVERSEAS_URL = '//roadrich.gyyx.cn/kf';
exports.CUSTOMER_SERVICE_OVERSEAS_URL = CUSTOMER_SERVICE_OVERSEAS_URL;
var VALIDATION_2_URL = '//validation2.gyyx.cn';
// 时间间隔
exports.VALIDATION_2_URL = VALIDATION_2_URL;
var DURATION = 1000;
// 分钟秒数
exports.DURATION = DURATION;
var MINUTE = 60;
// 发送短信类型
exports.MINUTE = MINUTE;
var SEND_MSG_SOURCE_TYPE = {
  LOGIN: 'SmsLoginStage',
  FIND_PW: 'FindPassword',
  PERSONAL: 'PersonalReg',
  MOBILE_REGISTER: 'MobilePhoneStageReg'
};
exports.SEND_MSG_SOURCE_TYPE = SEND_MSG_SOURCE_TYPE;
var RESPONSE_STATUS = {
  SUCCESS: 'SUCCESS'
};
exports.RESPONSE_STATUS = RESPONSE_STATUS;
var UPLOAD_URL = '//upload.gyyx.cn';
exports.UPLOAD_URL = UPLOAD_URL;